const getData = () => {
  return [
    // 文本
    {
      type: 1, // 字段类型
      defaultName: '文本',
      fieldName: '', // 字段名称
      rowType: 1, // 文本类型1：单行 2：多行
      default: 1, // 默认值（1：无，2：指定文本）
      value: '', // 指定文本内容（填写内容）
      required: 0, // 是否必填 0 不必填，1必填
      unique: 0, // 是否唯一，0：不唯一，1：唯一
      placeholder: '', // 提示信息
      search: 0, // 是否搜索，0：否，1：是
    },
    // 条码
    {
      type: 2, // 字段类型
      defaultName: '条码',
      fieldName: '', // 字段名称
      default: 1, // 默认值（1：无，2：指定文本）
      value: '', // 指定文本内容（填写内容）
      required: 0, // 是否必填 0 不必填，1必填
      unique: 0, // 是否唯一，0：不唯一，1：唯一
      scan: 0, // 仅可扫描输入（0：否 1：是）
      placeholder: '' // 提示信息
    },
    // 数值
    {
      type: 3, // 字段类型
      defaultName: '数值',
      fieldName: '', // 字段名称
      numberType: 1, // 数据格式（1：数值，2：金额，3：百分比）
      unit: '', // 单位
      unitPosition: 2, // 单位位置（1：前缀 2：后缀）
      fixed: 2, // 保留小数（仅数字填写）
      separator: 1, // 位数分割符（1：不显示，2：千分位，3：万分位）
      default: 1, // 默认值（1：无，2：指定数值）
      value: '', // 指定数值（仅数字填写）
      required: 0, // 是否必填 0 不必填，1必填
      unique: 0, // 是否唯一，0：不唯一，1：唯一
      placeholder: '' // 提示信息
    },
    // 日期时间
    {
      type: 4, // 字段类型
      defaultName: '日期时间',
      fieldName: '', // 字段名称
      dateType: 1, // 日期类型：1日期，2日期时间
      default: 0, //  默认值 0：无，1：当天日期，2：下一天日期，3：指定日期
      assignDate: '', // 指定日期
      required: 0, // 是否必填 0 不必填，1必填
      week: 0, // 显示星期
      placeholder: '' // 提示信息
    },
    // 选项
    {
      type: 5, // 字段类型
      defaultName: '选项',
      fieldName: '', // 字段名称
      selectType: 1, // 类型（1：单选，2：多选）
      showType: 1, // 选择方式（1：下拉，2：平铺）
      optionNum: 1, // 备选数
      optionName: '', // 选项名称（多项以竖线隔开）
      required: 0, // 是否必填 0 不必填，1必填
      placeholder: '' // 提示信息
    },
    // 位置
    {
      type: 6, // 字段类型
      defaultName: '位置',
      fieldName: '', // 字段名称
      inputType: 1, // 输入方式（1：仅可获取当前位置  2：可搜索指定位置）
      limit: 1, // 输入限制（1：不限制输入位置，2:通过固定地点限制，3：通过其他位置字段限制）
      position: '', // 指定地点
      nearby: '', // 地点周边范围
      required: 0, // 是否必填 0 不必填，1必填
      showMap: 0, // 显示地图（0：不显示，1：显示）
      placeholder: '' // 提示信息
    },
    // 图片
    {
      type: 7, // 字段类型
      defaultName: '图片',
      fieldName: '', // 字段名称
      required: 0, // 是否必填 0 不必填，1必填
      placeholder: '' // 提示信息
    },
    // 附件
    // {
    //   type: 8, // 字段类型
    //   defaultName: '附件',
    //   fieldName: '', // 字段名称
    //   required: 0, // 是否必填 0 不必填，1必填
    //   placeholder: '' // 提示信息
    // },
    // 区域
    {
      type: 9, // 字段类型
      defaultName: '区域',
      fieldName: '', // 字段名称
      required: 0, // 是否必填 0 不必填，1必填
      placeholder: '' // 提示信息
    },
    // 消息通知
    {
      type: 10, // 字段类型
      defaultName: '消息通知',
      fieldName: '', // 字段名称
      required: 0, // 是否必填 0 不必填，1必填
      // messageType: 1, // 消息类型 1：信息发送 2：短信发送
      // messageModel: '10002524', // 消息模板编号
      // 通知消息对象
      messageInfo: '',
      sendMoment: 1, // 消息发送时机 1：创建时发送 2：完成后发送
      placeholder: '', // 提示信息
      // 拓展信息对象，该对象不进行数据封装传递，只做后台数据的转换展示
      extendInfo: {
        sms: {},
        appMsg: {},
        wxMsg: {}
      }
    },
    {
      type: 11, // 字段类型
      defaultName: '部门',
      fieldName: '', // 字段名称
      required: 0, // 是否必填 0 不必填，1必填
      placeholder: '' // 提示信息
    },
    {
      type: 12, // 字段类型
      defaultName: '签名',
      fieldName: '', // 字段名称
      required: 0, // 是否必填 0 不必填，1必填
      placeholder: '' // 提示信息
    },
  ]
}
export default getData